export default function(ac, app) {
    var vrstaRada = app.getEntity('VrstaRada');

    vrstaRada.listView()
        .title('Vrsta rada')
        .icon('<i class="fa fa-archive fa-3x"></i>')
        .fields([
            ac.field('naziv'),
            ac.field('grupa', 'reference')
                .label('Grupa')
                .targetEntity(app.getEntity('GrupaRada'))
                .targetField(ac.field('naziv'))
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    vrstaRada.editionView()
        .title('Vrsta rada')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true,
                    focus: true
                }
            },

            {
                key:'grupa',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Grupa',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite grupu',
                    options: [],
                    required: true
                },
                controller: ['$scope', 'DS', function ($scope, DS) {
                    DS.findAll('GrupaRada').then(function (response) {
                        $scope.to.options = response;
                    });
                }]
            },

            {
                key:'boja',
                type: 'hInput',
                templateOptions: {
                    label: 'Boja',

                }
            },
        ]);

    return vrstaRada;
}



// WEBPACK FOOTER //
// ./app/components/vrstaRada/config.js